const InvoiceList = ({ invoices, onCreate, onView, onEdit, onDelete }) => {
  return (
    <div className="bg-white p-6 rounded shadow">
      <div className="flex justify-between mb-4">
        <h2 className="text-xl font-semibold">All Invoices</h2>
        <button
          onClick={onCreate}
          className="bg-primary text-white px-4 py-2 rounded"
        >
          + New Invoice
        </button>
      </div>

      <table className="w-full border">
        <thead className="bg-gray-200">
          <tr>
            <th className="p-2">Invoice No</th>
            <th className="p-2">Customer</th>
            <th className="p-2">Date</th>
            <th className="p-2">Total</th>
            <th className="p-2">Action</th>
          </tr>
        </thead>
        <tbody>
          {invoices.map((inv) => (
            <tr key={inv.id} className="border-t">
              <td className="p-2">{inv.id}</td>
              <td className="p-2">{inv.customerName}</td>
              <td className="p-2">{inv.invoiceDate}</td>
              <td className="p-2">₹ {inv.total}</td>
              <td className="p-2 flex gap-2">
                <button onClick={() => onView(inv)} className="text-blue-600">View</button>
                {/* <button onClick={() => onEdit(inv)} className="text-yellow-600">Edit</button> */}
                {/* <button onClick={() => onDelete(inv.id)} className="text-red-600">Delete</button> */}
              </td>
            </tr>
          ))}
          {invoices.length === 0 && (
            <tr>
              <td colSpan="5" className="text-center p-4 text-gray-500">
                No invoices found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default InvoiceList;
